// extracted by mini-css-extract-plugin
module.exports = {"container":"ca","logo":"cb","mainPanel":"cc"};